import ApiService from "./api.service"
import { server } from "./../core/data/config"
import { isMobile } from "react-device-detect";

export const historyResponseService = {
    sendhistoryResponse,
    sendhistorySpecificResponse
}



function sendhistorySpecificResponse(): any {

    const randomVal = 0;
    let url = "";
    let betDetailsSelected: any = {};
    let numReelResultsData: any = betDetailsSelected.bet.spins;
    let queryString = "mode=history&accountID=" + (window as any).GAME_INFO.accountID +
        "&path=" + (window as any).GAME_INFO.path +
        "&gameID=" + (window as any).GAME_INFO.gameID +
        "&accountID=" + (window as any).GAME_INFO.accountID +
        "&clientName=" + (window as any).GAME_INFO.clientName +
        "&lang=" + (window as any).GAME_INFO.lang +
        "&site=" + (window as any).GAME_INFO.site +
        "&version=" + (window as any).GAME_INFO.version +
        "&username=" + (window as any).GAME_INFO.username +
        "&channel=" + isMobile && "mobile" || "desktop" +
        "&betID=" + betDetailsSelected.betID +
        "&stake=" + betDetailsSelected.stake +
        "&currency=" + betDetailsSelected.currency +
        "&whenplaced=" + betDetailsSelected.whenplaced +
        "&whensettled=" + betDetailsSelected.whensettled +
        "&status=" + betDetailsSelected.status +
        "&returns=" + betDetailsSelected.returns +
        "&numReelResults=" + numReelResultsData.length +
        // "&spinIds=" + numReelResultsData.[j].id +
        // "&listSpinTypes=" + numReelResultsData.[j].type +
        "&buyInPrice=" + betDetailsSelected.buyInPrice+
        "&inGame=true";

    if (server.configGame.port === 0) {

        //url = server.configGame.endpoint + "/ISRecentSlotBets.jsp?" + queryString;
        url = (window as any).GAME_INFO.pathCDN + "/infrastr_slots_betdetails/?" + queryString;
    } else {
        //url = server.configGame.endpoint + ":" + server.configGame.port + "action?token=" + localStorage.getItem("playerId");
    }




    // let cheatApplied: any = localStorage.getItem("cheatModifiedRequest")

    let param: any = {};

    // if (cheatApplied == "") {

    // } else {

    //     url = url + cheatApplied
    // }

    const api = new ApiService(url);

    if (server.configGame.method === "get") {

        return api.get(url, param);
    }
    if (server.configGame.method === "post") {

        return api.post(url, param);
    }
}
function sendhistoryResponse(): any {

    const randomVal = 0;
    let url = "";

    var d = new Date();
    var n = d.getTime();
    let queryString = "mode=history&accountID=" + (window as any).GAME_INFO.accountID +
        "&gameID=" + (window as any).GAME_INFO.gameID +
        "&jurisdiction=" + (window as any).GAME_INFO.jurisdiction +
        "&now=" + n;
    if (server.configGame.port === 0) {

         url =  (window as any).GAME_INFO.path + "/IntegratedSlots" + "/ISRecentSlotBets.jsp?" + queryString;
         //url = "http://88.208.244.42/f1x2games/IntegratedSlots/ISRecentSlotBets.jsp?mode=history&accountID=187346&gameID=8108&jurisdiction=null&n=1644561219024";
    } else {
        //url = server.configGame.endpoint + ":" + server.configGame.port + "action?token=" + localStorage.getItem("playerId");
    }




    //let cheatApplied: any = localStorage.getItem("cheatModifiedRequest")

    let param: any = {};

    // if (cheatApplied == "") {
    //     param = {
    //         "gameRequest": { cmd: "spin" }
    //     }
    // } else {

    //     url = url + cheatApplied
    // }

    const api = new ApiService(url);

    if (server.configGame.method === "get") {

        return api.get(url, param);
    }
    if (server.configGame.method === "post") {

        return api.post(url, param);
    }
}
